import moment from 'moment';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import { FEEDBACK_ACCENT, FEEDBACK_LINK } from './constants';

function formatSessionWhen(summary) {
  if (summary?.StartTime) {
    const parsed = moment(summary.StartTime);
    if (parsed.isValid()) {
      return parsed.format('MMM D, YYYY • h:mm A');
    }
  }
  if (summary?.startTimestamp) {
    const parsed = moment.unix(Number(summary.startTimestamp));
    if (parsed.isValid()) {
      return parsed.format('MMM D, YYYY • h:mm A');
    }
  }
  return null;
}

const SessionContextCard = ({
  summary,
  loading,
  error,
  ownsSession,
  hasAccountSession,
  sessionId,
}) => {
  if (!sessionId) {
    return null;
  }

  if (loading) {
    return (
      <Box
        mt={3}
        p={2.5}
        sx={{
          backgroundColor: 'rgba(255,255,255,0.04)',
          borderLeft: `3px solid ${FEEDBACK_ACCENT}`,
        }}
      >
        <Typography fontSize={14} sx={{ opacity: 0.75 }}>
          Loading workout details…
        </Typography>
      </Box>
    );
  }

  if (error || !summary) {
    return (
      <Box
        mt={3}
        p={2.5}
        sx={{
          backgroundColor: 'rgba(255,255,255,0.04)',
          borderLeft: '3px solid rgba(255,255,255,0.25)',
        }}
      >
        <Typography fontSize={14} sx={{ opacity: 0.8 }}>
          {error || 'Workout details unavailable for this session.'}
        </Typography>
      </Box>
    );
  }

  const when = formatSessionWhen(summary);
  const boss = summary.ChalName || null;
  const workoutType = summary.SessionType || null;
  const player = summary.Username || null;
  const league = summary.League || null;

  return (
    <Box
      mt={3}
      p={2.5}
      sx={{
        backgroundColor: 'rgba(255, 107, 0, 0.08)',
        borderLeft: `3px solid ${FEEDBACK_ACCENT}`,
      }}
    >
      <Typography fontSize={12} fontWeight={700} letterSpacing="0.06em" sx={{ opacity: 0.7, mb: 1 }}>
        THIS WORKOUT
      </Typography>
      {player && (
        <Typography fontWeight={700} fontSize={18}>
          {player}
        </Typography>
      )}
      {when && (
        <Typography mt={0.5} fontSize={14} sx={{ opacity: 0.85 }}>
          {when}
        </Typography>
      )}
      <Box mt={1.5} display="flex" flexWrap="wrap" gap={1.5}>
        {workoutType && (
          <Typography fontSize={13} sx={{ opacity: 0.85 }}>
            {workoutType}
          </Typography>
        )}
        {boss && (
          <Typography fontSize={13} sx={{ opacity: 0.85 }}>
            vs {boss}
          </Typography>
        )}
        {league && (
          <Typography fontSize={13} sx={{ opacity: 0.85 }}>
            {league}
          </Typography>
        )}
        {summary.isRaidBattle && (
          <Typography fontSize={13} color={FEEDBACK_ACCENT} fontWeight={700}>
            Raid
          </Typography>
        )}
      </Box>

      {hasAccountSession && ownsSession === false && (
        <Typography mt={2} fontSize={13} color="error" role="alert">
          This session belongs to another member. Session feedback must come from the workout
          owner.
        </Typography>
      )}

      {!hasAccountSession && (
        <Typography mt={2} fontSize={13} sx={{ opacity: 0.8 }}>
          Session feedback requires your account.{' '}
          <Link to="/signin" state={{ from: `/feedback/session/${sessionId}` }} style={{ color: FEEDBACK_LINK }}>
            Log in
          </Link>{' '}
          or enter the username for this workout.
        </Typography>
      )}
    </Box>
  );
};

export default SessionContextCard;
